"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBCreditAnalysisPositive = function SvgBCreditAnalysisPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M16.04 46.324a2.215 2.215 0 01-1.832-.982l-5.08-7.577-5.081 7.48A2.215 2.215 0 010 43.999V14.769C0 6.612 6.612 0 14.77 0h3.02a2.215 2.215 0 010 4.43h-3.02c-5.71 0-10.34 4.63-10.34 10.34v22.02l2.873-4.231a2.252 2.252 0 011.84-.968c.737 0 1.427.37 1.838.983l5.08 7.576 5.251-7.658a2.215 2.215 0 013.692 0l6.011 9.15a2.215 2.215 0 11-3.692 2.43l-4.217-6.41-5.235 7.694a2.216 2.216 0 01-1.832.968z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M117.349 130.058H30.107a2.215 2.215 0 01-2.215-2.216V14.77c0-5.71-4.629-10.338-10.339-10.338h-1.395a2.215 2.215 0 110-4.431h1.373c8.148.02 14.749 6.62 14.77 14.77v110.857h85.048a2.215 2.215 0 110 4.43z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M127.754 67.237a2.215 2.215 0 01-2.216-2.215V14.843c0-5.71-4.628-10.338-10.338-10.338H37.078a2.215 2.215 0 010-4.431H115.2a14.77 14.77 0 0114.77 14.77v50.178a2.215 2.215 0 01-2.216 2.215zM127.754 130.058a2.215 2.215 0 01-2.216-2.216V109.02a2.215 2.215 0 114.431 0v18.823a2.215 2.215 0 01-2.215 2.216z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M64.985 63.73H44.086a2.215 2.215 0 010-4.432h20.899a2.215 2.215 0 010 4.431z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M82.464 53.258a2.215 2.215 0 01-2.215-2.216v-3.507a2.215 2.215 0 014.43 0v3.507a2.215 2.215 0 01-2.215 2.216zM92.935 53.258a2.215 2.215 0 01-2.215-2.216V40.615a2.215 2.215 0 014.43 0v10.427a2.215 2.215 0 01-2.215 2.216zM103.385 53.258a2.215 2.215 0 01-2.216-2.216v-17.42a2.215 2.215 0 114.431 0v17.42a2.215 2.215 0 01-2.215 2.216zM113.878 53.258a2.215 2.215 0 01-2.215-2.216v-24.42a2.215 2.215 0 014.43 0v24.42a2.215 2.215 0 01-2.215 2.216z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M64.985 74.238H44.086a2.215 2.215 0 010-4.431h20.899a2.215 2.215 0 010 4.43z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M49.95 50.954a2.215 2.215 0 01-2.216-2.216V44.05a2.215 2.215 0 114.43 0v4.69a2.215 2.215 0 01-2.214 2.215zM49.95 23.46a2.215 2.215 0 01-2.216-2.214v-4.018a2.215 2.215 0 014.43 0v4.018a2.215 2.215 0 01-2.214 2.215z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M49.95 45.452a8.337 8.337 0 01-5.753-2.215 2.23 2.23 0 113.065-3.242 3.995 3.995 0 002.717 1.027c2.016 0 3.648-1.381 3.648-3.065 0-1.824-1.927-2.954-3.833-3.087a10.62 10.62 0 01-2.784-.598c-3.153-1.27-5.11-3.906-5.11-6.89 0-4.18 3.626-7.54 8.08-7.54a8.382 8.382 0 015.648 2.127 2.215 2.215 0 01-2.954 3.286 3.95 3.95 0 00-2.673-.982c-2.016 0-3.648 1.374-3.648 3.065 0 1.69 1.787 2.607 2.334 2.828.479.156.975.253 1.477.288 4.578.377 7.894 3.53 7.894 7.488-.03 4.15-3.656 7.51-8.108 7.51zM64.903 97.602a2.215 2.215 0 01-1.735-3.588 51.205 51.205 0 0174.356-6.359 2.215 2.215 0 01-2.954 3.301 46.774 46.774 0 00-67.939 5.805 2.215 2.215 0 01-1.728.841z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M103.333 116.204a51.095 51.095 0 01-34.272-13.166 2.215 2.215 0 012.954-3.294 46.782 46.782 0 0068.012-5.73 2.215 2.215 0 013.47 2.747 51.02 51.02 0 01-40.164 19.443z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M103.333 77.945a2.215 2.215 0 01-2.215-2.216v-5.523a2.215 2.215 0 014.43 0v5.523a2.215 2.215 0 01-2.215 2.216zM128.308 84.185a2.215 2.215 0 01-1.108-.303 2.215 2.215 0 01-.805-3.028l2.836-4.792a2.215 2.215 0 013.832 2.215l-2.798 4.83a2.215 2.215 0 01-1.957 1.078zM78.358 84.185a2.215 2.215 0 01-1.92-1.108l-2.799-4.8a2.217 2.217 0 013.84-2.215l2.8 4.83a2.215 2.215 0 01-.813 3.027 2.156 2.156 0 01-1.108.266zM103.385 94.575a2.215 2.215 0 111.55-.633c-.425.417-1 .645-1.595.633h.045z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M103.385 107.077c-8.111-.012-14.684-6.584-14.696-14.695a14.51 14.51 0 011.396-6.226 2.215 2.215 0 114.01 1.883 10.124 10.124 0 00-.975 4.343c.008 5.665 4.599 10.256 10.265 10.264a10.242 10.242 0 009.29-14.607 2.215 2.215 0 114.01-1.875 14.68 14.68 0 01-13.3 20.913z",
    fill: "#285"
  })));
};

var _default = SvgBCreditAnalysisPositive;
exports["default"] = _default;